import React, { Suspense, lazy } from 'react';
import { AppLoading } from '../../../../loaders/loaders';
const TrailersGrid = lazy(() => import('./Trailer/Grid'));
const DollyGrid = lazy(() => import('./DollyGrid'));
const TractorGrid = lazy(() => import('./TractorGrid'));

const TabContainer = ({ tabId, dataList, ...props }) => {
  const tab = {
    0: <TrailersGrid trailerList={dataList} {...props} />,
    1: <TractorGrid tractorList={dataList} {...props} />,
    2: <DollyGrid dollyList={dataList} {...props} />
  };
  return <Suspense fallback={<AppLoading />}>{tab[tabId]}</Suspense>;
};

export default TabContainer;
